import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

export function Loader() {
    return <LinearProgress color="secondary" />;
}
